import get from "lodash/get";
import { Asset } from "./Asset";
import { Img } from "./Image";

export class Link {
  constructor(node) {
    this.url = get(node, `link`);
    this.type = get(node, `type`);
    this.title = get(node, `title`);
    this.target = get(node, `target`);
    this.displayTitle = get(node, `displayTitle`);
    this.subtext = get(node, `subtext.subtext`);
    this.linkAppearance = get(node, `linkAppearance`);
    this.asset = new Asset(get(node, `asset`));
    this.entry = get(node, `entry`);
    this.coverImage = new Img(get(node, `coverImage`));
  }
}
